"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import UiDialog from "../../../../components/dialog/UiDialog.vue";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import Question from "@/components/Question.vue";
import QuestionSlot from "@/components/QuestionSlot.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { RolelistModel } from "@/models/rolelist.model";
import API from "@ym-framework/api-utils";
import i18n from "@/lang";
import _ from "lodash";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import AccountBindShop from "@/views/teamItems/components/dialog/AccountBindShop.vue";
import { AccountSessionMixins } from "@/service/account-session";
export class formController extends UiFormController {
  constructor() {
    super(...arguments);
    this.account = "";
    this.name = "";
    // 加入一个正则校验，可为空，但只要输入内容，则至少包含一位字母且仅限数字或字母
    // @UiFormAnnotations.Rule([
    //   {
    //     validator: (rule: any, value: string, callback: any) => {
    //       if (!value || value === "") {
    //         return callback(true);
    //       }
    //       if (!/^(?=.*[a-zA-Z]).*$/.test(value) || !/^(?=.*\d).*$/.test(value)) {
    //         return callback(new Error(i18n.t("team_management.edit_subcount.loginaccount.message") as string));
    //       }
    //       return callback(true);
    //     },
    //     message: i18n.t("team_management.edit_subcount.loginaccount.message") as string,
    //     trigger: "blur",
    //   },
    // ])
    this.loginaccount = "";
    this.password = "";
    this.role = "";
    this.department = [];
    this.remark = null;
    this.device_limit = "all_device_permanent";
    this.device_date = "all_date_permanent";
    this.login_device_limit = [];
    this.start_time = "00:00";
    this.end_time = "23:59";
    this.powers = [];
    this.loginPlatformLimits = {
      windows: false,
      mac: false,
      wechat: false,
      android: false
    };
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("team_management.edit_subcount.name.message"),
      trigger: "blur"
    }
  ])
], formController.prototype, "name", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "team_management.edit_subcount.password.message"
      ),
      trigger: "blur"
    }
  ])
], formController.prototype, "password", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("team_management.edit_subcount.role.message"),
      trigger: "blur"
    }
  ])
], formController.prototype, "role", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "team_management.edit_subcount.department.message"
      ),
      trigger: "blur"
    }
  ])
], formController.prototype, "department", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "team_management.login_restrictions.dialog.equipment_limit.message"
      ),
      trigger: "blur"
    }
  ])
], formController.prototype, "device_limit", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "team_management.login_restrictions.dialog.time_limit.message"
      ),
      trigger: "blur"
    }
  ])
], formController.prototype, "device_date", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "team_management.login_restrictions.dialog.device_limit.message"
      ),
      trigger: "blur"
    }
  ])
], formController.prototype, "login_device_limit", 2);
let UserLoginLimit = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.role_options = [];
    this.all_department = [];
    this.choose_shops = [];
    this.submit_loading = false;
    this.shop_powers = [
      {
        key: "SHOP_CREATE",
        name: this.$t("team_management.other_way.dialog.shop_create")
      },
      {
        key: "SHOP_EDIT",
        name: this.$t("team_management.action_power.shop_edit")
      },
      {
        key: "SELECT_SHOP_PASSWORD",
        name: this.$t("team_management.other_way.dialog.select_shop_password")
      },
      {
        key: "DELETE_CACHE",
        name: this.$t("team_management.other_way.dialog.delete_save")
      },
      {
        key: "VIDEO_AUTH",
        name: this.$t("team_management.action_power.dialog.add_video")
      },
      {
        key: "COOKIE_BACKUP",
        name: this.$t("team_management.other_way.dialog.cookie_backup")
      },
      {
        key: "SHOW_LAST_LOGIN",
        name: this.$t("team_management.other_way.dialog.show_last_login")
      },
      {
        key: "SHOW_SHOP_AUTH_COUNT",
        name: this.$t("team_management.other_way.dialog.show_shop_auth_count")
      },
      {
        // cookie导入权限
        key: "IMPORT_COOKIE",
        name: this.$t("team_management.other_way.dialog.cookie_import_power")
      },
      {
        key: "VD_NAME_INVISIBLE",
        name: this.$t("team_management.other_way.dialog.not_vd_name_invisible"),
        question: this.$t("team_management.other_way.dialog.vd_name_invisible_question")
      },
      // {
      //   key: "VD_LIST_MODE_INVISIBLE",
      //   name: this.$t("team_management.other_way.dialog.vd_list_mode"),
      // },
      {
        key: "NOT_VD_LIST_MODE_INVISIBLE",
        name: this.$t("team_management.other_way.dialog.not_vd_list_mode"),
        question: this.$t("team_management.other_way.dialog.not_vd_list_mode_question")
      },
      {
        key: "PLUG_MANAGEMENT_PERSON",
        name: this.$t("team_management.action_power.dialog.extensions_install"),
        question: this.$t(
          "team_management.action_power.dialog.extensions_install_question"
        )
      },
      {
        key: "PLUG_MANAGEMENT",
        name: this.$t("team_management.action_power.dialog.extensions_manager"),
        question: this.$t(
          "team_management.action_power.dialog.extensions_manager_question"
        )
      }
    ];
    this.team_powers = [
      // {
      //   key: "FORBIDDEN_AUTH_VD_MANAGER",
      //   name: this.$t(
      //     "team_management.other_way.dialog.forbidden_auth_vd_manager"
      //   ),
      // },
      {
        key: "NOT_FORBIDDEN_AUTH_VD_MANAGER",
        name: this.$t(
          "team_management.other_way.dialog.not_forbidden_auth_vd_manager"
        ),
        question: this.$t("team_management.other_way.dialog.not_forbidden_auth_vd_manager_question")
      },
      // {
      // key: "ADMIN_DISALLOW_MODIFY_SELF_POWER",
      // name: this.$t(
      //   "team_management.other_way.dialog.admin_disallow_modify_self_power"
      // ),
      // },
      // {
      //   key: "NOT_ADMIN_DISALLOW_MODIFY_SELF_POWER",
      //   name: this.$t(
      //     "team_management.other_way.dialog.not_admin_disallow_modify_self_power"
      //   ),
      //   question:this.$t("team_management.other_way.dialog.not_admin_disallow_modify_self_power_question"),
      // },
      {
        key: "PASSWORD_EDIT",
        name: this.$t("team_management.other_way.dialog.allow_edit")
      },
      {
        key: "TEAM_LOGIN_SETTING",
        name: this.$t("team_management.other_way.dialog.show_team_login")
      },
      {
        key: "TEAM_LOGIN_APPROVAL",
        name: this.$t("team_management.other_way.dialog.team_login_management")
      },
      {
        key: "ACCESS_CONTROL_SETTING",
        name: this.$t("team_management.other_way.dialog.setting_access_control")
      },
      {
        key: "ACCESS_CONTROL_APPROVAL",
        name: this.$t("team_management.other_way.dialog.access_control_approval")
      },
      {
        key: "IN_PROCESS_MONITORING_SETTING",
        name: this.$t("team_management.other_way.dialog.inprogress_supervision_setting")
      },
      {
        key: "IN_PROCESS_MONITORING_APPROVAL",
        name: this.$t("team_management.other_way.dialog.inprogress_supervision_approval")
      }
    ];
    this.cost_powers = [
      {
        key: "VD_NEW",
        name: this.$t("team_management.other_way.dialog.vd_new")
      },
      {
        key: "VD_RENEW",
        name: this.$t("team_management.other_way.dialog.vd_renew")
      },
      {
        key: "RECHARGE_COIN",
        name: this.$t("team_management.other_way.dialog.recharge_coin_power")
      },
      {
        key: "COIN_DETAIL",
        name: this.$t("team_management.other_way.dialog.coin_info")
      },
      {
        key: "VIEW_ORDER_DETAIL",
        name: this.$t("team_management.other_way.dialog.view_order_detail")
      },
      {
        key: "VD_UPGRADE",
        name: this.$t("team_management.other_way.dialog.vd_upgrade")
      },
      {
        key: "INVOICE_MANAGEMENT",
        name: this.$t("team_management.other_way.dialog.invoice_management")
      }
    ];
    this.service_powers = [
      {
        key: "OPEN_API",
        name: this.$t("team_management.action_power.open_api")
      }
    ];
    this.props = {
      multiple: true,
      emitPath: false,
      value: "id",
      checkStrictly: true
    };
    this.controller = new formController();
    this.sub_account = new RolelistModel();
    this.activeName = "init";
  }
  formatdata(data) {
    return __async(this, null, function* () {
      for (let item of data) {
        if (item.hasOwnProperty("children") === false) {
          continue;
        }
        if (item.children === null) {
          delete item.children;
          continue;
        }
        if (item.children.length === 0) {
          delete item.children;
          continue;
        }
        if (item.children !== void 0 && item.children.length > 0) {
          this.formatdata(item.children);
        }
      }
      return data;
    });
  }
  open(item) {
    return __async(this, null, function* () {
      let account_info = yield API.get(
        `api://base.auth/api/v8/users/${item.guid}`
      );
      this.sub_account = item;
      let result = yield API.get(`api://base.auth/api/v1/roles`);
      this.role_options = result.data.datas;
      let response = yield API.get(`api://base.auth/api/v1/departments`);
      let arr = [];
      arr.push(response.data);
      arr = yield this.formatdata(arr);
      this.all_department = arr;
      let dep_ids = [];
      for (let data of item.department) {
        dep_ids.push(data.id);
      }
      let shop_response = yield API.get(
        `api://base.auth.pro/v1/user/${item.guid}/auth-shops`
      );
      this.choose_shops = this.formatShops(shop_response.data.datas);
      this.controller.account = item.account;
      this.controller.name = item.name;
      this.controller.password = account_info.data.original_password;
      this.controller.role = item.role;
      this.controller.department = dep_ids;
      this.controller.remark = item.comment ? item.comment : null;
      this.controller.device_limit = account_info.data.login_limit.device_limit;
      this.controller.powers = account_info.data.powers;
      if (!account_info.data.powers.includes("VD_LIST_MODE_INVISIBLE")) {
        this.controller.powers.push("NOT_VD_LIST_MODE_INVISIBLE");
      }
      if (account_info.data.role) {
        if (!account_info.data.powers.includes("FORBIDDEN_AUTH_VD_MANAGER") && account_info.data.role.indexOf("admin") !== -1) {
          this.controller.powers.push("NOT_FORBIDDEN_AUTH_VD_MANAGER");
        }
      } else {
        if (!account_info.data.powers.includes("FORBIDDEN_AUTH_VD_MANAGER")) {
          this.controller.powers.push("NOT_FORBIDDEN_AUTH_VD_MANAGER");
        }
      }
      this.controller.device_date = account_info.data.login_limit.date_limit;
      this.controller.end_time = account_info.data.login_limit.end_time_limit;
      this.controller.start_time = account_info.data.login_limit.start_time_limit;
      this.controller.loginaccount = account_info.data.login_name ? account_info.data.login_name : "";
      this.controller.loginPlatformLimits = account_info.data.loginPlatformLimits;
      if (account_info.data.loginPlatformLimits.wechat) {
        this.controller.login_device_limit.push("WECHAT_APP");
      }
      if (account_info.data.loginPlatformLimits.android) {
        this.controller.login_device_limit.push("ANDROID");
      }
      if (account_info.data.loginPlatformLimits.windows) {
        this.controller.login_device_limit.push("WINDOWS");
      }
      if (account_info.data.loginPlatformLimits.mac) {
        this.controller.login_device_limit.push("MAC");
      }
      this._edit_account.show();
    });
  }
  formatShops(datas) {
    let shops = [];
    for (let shop of datas) {
      let item = {
        id: shop.oldId,
        label: shop.name
      };
      shops.push(item);
    }
    return shops;
  }
  setShops(datas) {
    this.choose_shops = datas.datas;
  }
  getShops(item) {
    if (item.length > 0) {
      let arr = [];
      for (let data of item) {
        arr.push(data.label);
      }
      return arr.join(",");
    }
    return this.$t("virtualdesktopform.choose_users");
  }
  openSplitShop() {
    this._edit_bind_shop.open_new(this.choose_shops);
  }
  submit() {
    return __async(this, null, function* () {
      try {
        if (this.controller.loginaccount !== null && this.controller.loginaccount !== "") {
          if (!/^(?=.*[A-Za-z])[A-Za-z0-9]+$/.test(this.controller.loginaccount)) {
            this.$message.error(
              i18n.t(
                "team_management.edit_subcount.loginaccount.message"
              )
            );
            return;
          }
        }
        this.submit_loading = true;
        let _role_choose = _.find(this.role_options, {
          id: this.controller.role
        });
        if (_role_choose !== void 0 && _role_choose.name === "\u7BA1\u7406\u5458") {
          yield UiConfirm.confirm(
            this.$t("team_management.edit_subcount.confirm.content"),
            this.$t("team_management.edit_subcount.confirm.title"),
            {
              confirmButtonText: this.$t("team_management.confirm"),
              cancelButtonText: this.$t("shopdefaultview.cancel")
            }
          );
        }
        if (!this.controller.powers.includes("NOT_VD_LIST_MODE_INVISIBLE")) {
          if (!this.controller.powers.includes("VD_LIST_MODE_INVISIBLE")) {
            this.controller.powers.push("VD_LIST_MODE_INVISIBLE");
          }
        } else {
          this.controller.powers = this.controller.powers.filter((power) => power !== "VD_LIST_MODE_INVISIBLE");
          this.controller.powers = this.controller.powers.filter((power) => power !== "NOT_VD_LIST_MODE_INVISIBLE");
        }
        if (!this.controller.powers.includes("NOT_FORBIDDEN_AUTH_VD_MANAGER")) {
          if (!this.controller.powers.includes("FORBIDDEN_AUTH_VD_MANAGER")) {
            this.controller.powers.push("FORBIDDEN_AUTH_VD_MANAGER");
          }
        } else {
          this.controller.powers = this.controller.powers.filter((power) => power !== "FORBIDDEN_AUTH_VD_MANAGER");
          this.controller.powers = this.controller.powers.filter((power) => power !== "NOT_FORBIDDEN_AUTH_VD_MANAGER");
        }
        let shop_ids = [];
        for (let item of this.choose_shops) {
          shop_ids.push(item.id);
        }
        if (this.controller.login_device_limit.includes("WECHAT_APP")) {
          this.controller.loginPlatformLimits.wechat = true;
        } else {
          this.controller.loginPlatformLimits.wechat = false;
        }
        if (this.controller.login_device_limit.includes("ANDROID")) {
          this.controller.loginPlatformLimits.android = true;
        } else {
          this.controller.loginPlatformLimits.android = false;
        }
        if (this.controller.login_device_limit.includes("WINDOWS")) {
          this.controller.loginPlatformLimits.windows = true;
        } else {
          this.controller.loginPlatformLimits.windows = false;
        }
        if (this.controller.login_device_limit.includes("MAC")) {
          this.controller.loginPlatformLimits.mac = true;
        } else {
          this.controller.loginPlatformLimits.mac = false;
        }
        yield API.put(`api://base.auth/api/v8/users/${this.sub_account.guid}`, {
          account: this.controller.account,
          name: this.controller.name,
          original_password: this.controller.password,
          comment: this.controller.remark,
          role: this.controller.role,
          departments: this.controller.department,
          login_limit: {
            date_limit: this.controller.device_date,
            device_limit: this.controller.device_limit,
            start_time_limit: this.controller.start_time,
            end_time_limit: this.controller.end_time
          },
          loginPlatformLimits: this.controller.loginPlatformLimits,
          powers: this.controller.powers,
          shops: shop_ids,
          login_name: this.controller.loginaccount !== "" && this.controller.loginaccount !== null ? this.controller.loginaccount : null
        });
        this.$emit("success");
        this._edit_account.hide();
        this.submit_loading = false;
      } catch (error) {
        this.submit_loading = false;
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("bind-account-shop")
], UserLoginLimit.prototype, "_edit_bind_shop", 2);
__decorateClass([
  Ref("edit-account-dialog")
], UserLoginLimit.prototype, "_edit_account", 2);
UserLoginLimit = __decorateClass([
  Component({
    components: {
      Question,
      PasswordInput,
      UiForm,
      UiDialog,
      UiSubmit,
      QuestionSlot,
      AccountBindShop
    }
  })
], UserLoginLimit);
export {
  UserLoginLimit as default
};
